import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { CONTENT_BLOCK, DROPDOWN } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, RED_BUTTON, WHITE } from "./baseModal/colours";

// Preserve the existing manual-invoice editor. The new email-confirmation flow
// applies to Stripe automatic payments; manual invoice terms are unchanged.
export default function ManualBillingCycleModal({ program, classification = "Program", onClose }) {
  const [billingCycle, setBillingCycle] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!billingCycle || saving) return;
    setSaving(true);
    let saved = false;
    try {
      const type = classification === "Online" ? "virtual" : "programs";
      const response = await axios.post(`${process.env.REACT_APP_API}/partners/${type}/edit-billing-cycle`, {
        programId: program.id, partnerId: program.partnerId,
        billingCycle, orderId: program.manualOrder?.id
      });
      if (!response.data.success) throw new Error(response.data.message || "Error updating billing cycle");
      toast.success("Billing cycle updated");
      saved = true;
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setSaving(false);
    }
    if (saved) onClose();
  };
  return <BaseModal title="Edit billing cycle" fields={[
    { type: DROPDOWN, data: { name: "Billing Cycle Anchor", value: billingCycle,
      placeholder: "Please select a billing cycle anchor", handleChange: event => setBillingCycle(event.target.value),
      choices: [{ value: "month-start", text: "Beginning of Month" }, { value: "month-end", text: "End of Month" }], isDisabled: saving } },
    { type: CONTENT_BLOCK, data: { content: "Warning: Any changes to an upcoming invoice will move the due date into the future. We recommend adding a prorated charge to the upcoming invoice to collect any remaining balance." } }
  ]} buttons={[
    { name: saving ? "Updating…" : "Update", handleClick: submit, isDisabled: !billingCycle || saving, buttonColour: BLUE_BUTTON, textColour: WHITE },
    { name: "Cancel", handleClick: onClose, isDisabled: saving, buttonColour: RED_BUTTON, textColour: WHITE }
  ]} handleClose={onClose} height="65vh" midSectionHeight="49vh" />;
}
